import { render, staticRenderFns } from "./ProviderBitcoin.vue?vue&type=template&id=5f1e4e36&scoped=true&"
import script from "./ProviderBitcoin.vue?vue&type=script&lang=js&"
export * from "./ProviderBitcoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e4e36",
  null
  
)

export default component.exports